module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-brands-400.svg?82927ee13ebdbbb7ae72dc00b86624ce";